import styled from 'styled-components';
import { beigeColor, blueDarkColor } from '../../styles/GlobalStyle';
import { VolumeProgramBorder } from '../game-interface/common/styles-components';
import { TILE_SIZE_LARGE } from '../../styles/global';


interface WrapperProps {
	isVisible: boolean;
}

export const WrapperXP = styled.div<WrapperProps>`
  width: fit-content;
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  flex-direction: column;
  padding: 0.6vmin;
  padding-top: 0.2vmin;
  border-top: 0.3vmin solid ${blueDarkColor};
  border-radius: 1.2vmin 1.2vmin 0 0;
  background-color: ${blueDarkColor};
  ${VolumeProgramBorder}
`;

export const HeaderXP = styled.div`
  height: fit-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: inset 0px -10px 12px -8px rgba(0, 0, 0, 0.5);
  border-bottom: solid 0.2vmin ${blueDarkColor};
`;

export const TitleXP = styled.span`
  font-size: 1.7vmin;
  font-weight: bolder;
  color: white;
  display: flex;
  align-items: center;
`;

export const MenuXP = styled.div`
  height: ${TILE_SIZE_LARGE + 0.5}vmin;
  background-color: ${beigeColor};
  border-radius: 0.3vmin 0.3vmin 0 0;
  display: flex;
  justify-content: flex-start;
`;

export const ButtonsXP = styled.div`
  display: flex;
`;